import { DefaultTheme } from 'styled-components';

const sizes: DefaultTheme['sizes'] = {
  socialIconSize: '48px',
  commonIconSize: '44px',
  coverSize: '60px',
  coverSizeSmall: '40px',
  coverSizeMobile: '48px',
  coverSizeRounded: '200px',
  coverSizeRoundedMobile: '130px',
  navbar: '100px',
  navbarMobile: '88px',
};

export default sizes;
